<template>
  <rs-container style="height:100%;">
    <div v-if="maskFlag" class="msgDivImg"></div>
    <rs-header class="main_header" style="height:52px;background: #1d3262;">
      <p class="header_title">
        <span class="logo">
          <img src="../../assets/images/login/07logo.png" />
<!--          <p>{{imgForm.customIndexTitle}}</p>-->
          <p style="font-size:18px;">商管平台</p>
        </span>
        <span v-viewButton v-html="!isCollapse?'&#xe77b;':'&#xe77a;'" class="font_family menuShouqi" @click="isCollapse = !isCollapse"></span>

      </p>
      <div class="main rs-container tab-top">
        <rs-tabs v-viewButton v-model="editableTabsValue" type="card" @tab-click="tabClick" @tab-remove="removeTab" class="main rs-container is-vertical" style="height:100%">
          <rs-tab-pane v-loading="item.loading" element-loading-text="拼命加载中" element-loading-spinner="rs-icon-loading" element-loading-background="rgba(249, 249, 249, 0.8)" v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name" :closable="item.closeable" class="rs-main">
            <!-- <iframe id="main_iframe" ref="mainIframe" :src="item.url"></iframe> -->
          </rs-tab-pane>
        </rs-tabs>
        <rs-button v-show="editableTabs.length" @click="closeAllTabs" size="small" class="close-all-button" icon="rs-icon-close"></rs-button>
        <rs-popover trigger="hover" width="934" popper-class="all-tabs-popover">
          <div class="booth-box">
            <div class="orgrole-wrap">
              <p :class="['orgrole-item', {'orgrole-item-active':item.name==editableTabsValue}]" @click="tabClick(item)" v-for="(item, index) in editableTabs" :key="index">
                <span>{{item.title}}</span><i @click.stop="removeTab(item.name)" class="rs-icon-close"></i>
              </p>
            </div>
          </div>
          <rs-button v-show="editableTabs.length" slot="reference" size="small" class="close-all-button">全览</rs-button>
        </rs-popover>
      </div>
      <div class="button_block" v-viewButton>
        <rs-dropdown trigger="click" @command="handleCommand" class="user_info_block" @visible-change="changeClass">
          <span class="user_info" :class="{cur:show}"><span class="font_span">{{userName}}</span> 您好！</span>
          <rs-dropdown-menu slot="dropdown">
            <rs-dropdown-item command="change"><i class="icon_password"></i>修改密码</rs-dropdown-item>
            <rs-dropdown-item command="logout"><i class="icon_logout"></i>退出登录</rs-dropdown-item>
          </rs-dropdown-menu>
        </rs-dropdown>
      </div>
    </rs-header>
    <rs-container class="main-container" :class="{'no-editable-tabs':editableTabs.length == 0}" style="height:calc(100% - 52px)">
      <menu-div :isCollapse="isCollapse" ref="menu" @jumpUrl="jumpUrl" @hasSy="hasSy" @getMenuResource="getMenuResource"></menu-div>
      <div v-if="nopower==true" class="nopower">
        <img src="../../assets/images/icon-no-auth.png" alt />
        <p class="no-auth-text">您暂时无法访问系统</p>
        <p class="no-auth-text-span">如需访问，请提交账号开通流程，如已提交流程，请联系IT客服处理</p>
      </div>
      <rs-main v-else :class="{'no-editable-main':editableTabs.length == 0}">
        <rs-tabs v-viewButton v-model="editableTabsValue" type="card" @tab-remove="removeTab" class="main rs-container is-vertical home-main" style="height:100%">
          <div class='name-text' v-if="editableTabs.length == 0">
            <span>欢迎使用商管平台</span>
          </div>
          <rs-tab-pane v-loading="item.loading" element-loading-text="拼命加载中" element-loading-spinner="rs-icon-loading" element-loading-background="rgba(249, 249, 249, 0.8)" v-for="(item, index) in editableTabs" :key="item.name" :label="item.title" :name="item.name" :closable="item.closeable" class="rs-main">
            <iframe id="main_iframe" ref="mainIframe" :src="item.url"></iframe>
          </rs-tab-pane>
        </rs-tabs>
        <!-- <div style="height:100%;position: absolute;width:100%;" v-if="loadingFlagHome"
                     v-loading="loadingFlagHome"
                     element-loading-text="拼命加载中"
                     element-loading-spinner="rs-icon-loading"
                     element-loading-background="rgba(255, 255, 255, 0.8)">
                </div> -->
        <iframe v-noTabIframe id="iframeHome" class="iframeHomeIndexArr" ref="mainIframe" :src="iframeUrl"></iframe>
        <!--</div>-->
      </rs-main>
    </rs-container>
    <change-password ref="ChangePassword" :showPassword="showPassword" @hidePassword="hidePassword"></change-password>
  </rs-container>
</template>

<script>
import Utils from "@/utils/utils";
import Http from "@/api/api";
import OaApi from "@/api/oa";
import MenuDiv from "@/components/leftMenu";
import changePassword from "../../components/changePassword";
import redirect from "@/webconfig";
import ImgApi from "@/api/imgSetter";
export default {
  name: "home",
  components: {
    MenuDiv,
    changePassword,
  },
  data() {
    return {
      isLoding: true,
      show: false,
      dialogVisible: false,
      showPassword: false,
      showQuestion: false,
      UserLeftComplaint: 0,
      userName: "",
      shopName: "",
      editableTabsValue: "main",
      editableTabs: [],
      tabIndex: 1,
      NoticeImgData: "",
      fresh: false,
      maskFlag: false,
      iframeUrl: "",
      collapseFlag: false, // 菜单展开合并,
      loadingFlagHome: false,
      imgForm: {},
      oaCode: "", // 是否从oa进入
      nopower: false,
      isCollapse: false, // 菜单展开收起
    };
  },
  methods: {
    // 从oa跳转进来获取重定向信息
    getZjInfo() {
      OaApi.getZjInfo().then((res) => {
        this.$store.dispatch("setOaZjInfo", res.data.data);
      });
    },
    changeClass(e) {
      this.show = e;
    },
    changeMenu() {
      this.collapseFlag = !this.collapseFlag;
      this.$refs.menu.bindCollapse();
    },
    // 获取图片
    getImg() {
      ImgApi.findAllConfig({
        configType: "custom",
        pageNum: 1,
        pageSize: 99,
      }).then((res) => {
        res.data.data.list.forEach((item) => {
          this.imgForm[item.configType] = item.configValue;
        });
        Utils.setSession("imgInfo", this.imgForm);
        Utils.setLocalStorage("imgInfo", this.imgForm);
        this.$forceUpdate();
      });
    },
    handleCommand(command) {
      if (command === "change") {
        this.showPassword = true;
        this.$refs.ChangePassword.init();
      } else if (command === "logout") {
        this.$confirm("确定退出吗", "提示", {
          confirmButtonText: "退出",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            Http.logout().then((res) => {
              Utils.delLocalStorage("userInfo");
              Utils.delLocalStorage("buttonResource");
              Utils.delSessionStorage("userInfo");
              Utils.delSessionStorage("leftMenuInit");
            });
          })
          .catch(() => {});
      }
    },
    handledrop(command) {
      // if(command === 'question'){
      //     this.showQuestion = true
      // } else if(command === 'help'){
      //     //postMessage.openTab('公告','/administration/#/administrationNoticeList')
      // }
    },
    hidePassword() {
      this.showPassword = false;
    },
    hideQuestion() {
      this.showQuestion = false;
    },
    jumpUrl(url, type) {
      let array = url.split("&");
      let Url = url.split("&")[1];
      array.forEach((item, index) => {
        if (index == 1) {
          Url = item;
        } else if (index > 1) {
          Url = Url + "&" + item;
        }
      });
      if (type == "http") {
        let title = url.split("&")[0];
        this.addTab(title, Url, "", type);
      } else {
        Url = Url || "/#/" + new Date().getTime();
        let title = url.split("&")[0];
        this.addTab(title, Url);
      }
    },
    setUrl(url) {
      url = url
        .replace(/%2F/g, "/")
        .replace(/%23/g, "#")
        .replace(/%3D/g, "=")
        .replace(/%26/g, "&")
        .replace(/%3F/g, "?");
      this.$router.push({
        query: {
          link: url,
          hash: new Date().getTime(),
          code: this.oaCode,
        },
      });
    },
    hasSy() {
      //判断是否有首页
      this.addTab("首页", "/#/worktable");
    },
    // 判断菜单权限
    getMenuResource(data) {
      let { href, link } = this.$route.query;
      if (!data || !data.length) {
        this.nopower = true;
        return;
      }

      // if(!href && !link) {
      //     this.iframeUrl = data[0].resourceUrl || '/#/main'
      //     return
      // }
    },
    // 全部关闭所有页签
    closeAllTabs() {
      this.$confirm("确定要关闭所有弹窗吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.editableTabs.forEach((item) => {
            this.removeTab(item.name);
          });
        })
        .catch(() => {});
    },
    postMessageListener(e) {
      const vm = this;
      if (e.data.type === "showMask") {
        this.maskFlag = true;
      } else if (e.data.type === "hideMask") {
        this.maskFlag = false;
      } else if (e.data.type === "jumpUrl") {
        this.jumpUrl(e.data.url);
      } else if (e.data.type === "noLogin") {
        localStorage.removeItem("userInfo");
        let oaCode = Utils.getQueryString("code") || "";
        if (!oaCode) {
          top.location.href = top.location.href.split("/#/")[0] + "/#/login";
        } else {
          let url = `${redirect.baseUrl}/idp/profile/SAML2/Redirect/GLO?redirctToUrl=${redirect.redirectUri}&redirectToLogin=true&entityId=${redirect.clientId}`;
          top.location.href = url;
          //top.location.href = `${redirect.baseUrl}/login`
        }
      } else if (e.data.type === "openTab") {
        this.addTab(e.data.name, e.data.targetUrl, e.data.currentUrl);
      } else if (e.data.type === "alertDialog") {
        console.log(e.data.data);
      } else if (e.data.type == "closeOtherTab") {
        if (e.data.targetUrl) {
          vm.editableTabs.forEach((item) => {
            // if(item.url==decodeURI(e.data.currentUrl)){  //防止url中 中文转译
            if (item.url.split("?")[0] == e.data.targetUrl.split("?")[0]) {
              //防止url中 中文转译
              //关闭老页面
              vm.removeTab(item.name);
            }
          });
        }
      } else if (e.data.type == "closeAllTab") {
        vm.editableTabs.forEach((item) => {
          vm.removeTab(item.name);
        });
      } else if (e.data.type === "closeTab") {
        if (e.data.currentUrl) {
          vm.editableTabs.forEach((item) => {
            // console.log(item);
            // if(item.url==decodeURI(e.data.currentUrl)){  //防止url中 中文转译
            if (item.url.split("?")[0] == e.data.currentUrl.split("?")[0]) {
              //防止url中 中文转译
              //关闭老页面
              vm.removeTab(item.name);
              //返回对应的页面
              const fromName = item.from.split("/#/")[1].split("?")[0];
              if (e.data.refresh) {
                vm.editableTabs.forEach((tab) => {
                  if (fromName == tab.name) {
                    let branch = tab.url.match(/\/(\w*?)(?=\/#\/)/);
                    // console.log(branch);
                    if (
                      branch &&
                      location.href.match(/\/(\w*?)(?=\/#\/)/) &&
                      location.href.match(/\/(\w*?)(?=\/#\/)/)[0] === branch[0]
                    ) {
                      branch = null;
                    }
                    let url = branch
                      ? branch[0] + "/#/" + tab.url.split("/#/")[1]
                      : "/#/" + tab.url.split("/#/")[1];
                    // let url ='/'+branch[0]+'/#/'+str.split('/#/')[1]
                    // console.log(url);
                    vm.addTab(tab.title, url, tab.from);
                  }
                });
              } else {
                this.editableTabsValue = fromName;
              }
            }
          });
        } else {
          // this.$router.back(-1)
          this.removeTab(this.editableTabsValue);
        }
      } else if (e.data.type == "hideLoading") {
        this.loadingFlagHome = false;
        if (e.data.url) {
          const url = window.location.href.split("/#/")[0] + e.data.url;
          if (this.editableTabs && this.editableTabs.length > 0) {
            this.editableTabs.forEach((item) => {
              // if(item.url.split('?')[0] == url){
              item.loading = false;
              // }
            });
          }
        }
      } else if (e.data.type == "showLoading") {
        this.loadingFlagHome = true;
        if (e.data.url) {
          const url = window.location.href.split("/#/")[0] + e.data.url;
          this.editableTabs.forEach((item) => {
            if (item.url.split("?")[0] == url) {
              item.loading = true;
            }
          });
        }
      }
    },
    addTab(title, url, from = "/#/main") {
      let flag = -1;
      let name;
      if (url) {
        if (url.split("/#/").length > 1) {
          name = url.split("/#/")[1].split("?")[0];
        } else {
          name = url.split("?")[0];
          url = "/#" + url;
        }
      } else {
        name = new Date().getTime();
        url = name;
      }

      this.editableTabs.forEach((v, i) => {
        if (v.name === name) {
          flag = i;
        }
      });
      // this.setUrl(url)
      if (flag === -1) {
        this.editableTabs.push({
          title: title,
          name: name,
          url: window.location.href.split("/#/")[0] + url,
          closeable: true,
          from: from,
          loading: true,
        });
      } else {
        // this.iframeUrl = window.location.href.split('/#/')[0] + url
        this.editableTabs[flag].url =
          window.location.href.split("/#/")[0] + url;
        this.editableTabs[flag].title = title;
        this.$refs.mainIframe[flag].contentWindow.location.href =
          window.location.href.split("/#/")[0] + url;
        this.$refs.mainIframe[flag].contentWindow.location.reload();
      }
      this.editableTabsValue = name;
    },
    // tab切换
    tabClick(val) {
      this.editableTabsValue = val.name;
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }

      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter((tab) => tab.name !== targetName);
    },
  },
  created() {
    top.window.$message = this.$message; // 消息框
    top.window.$confirmDialog = this.$confirmDialog; // 消息框
    top.window.$dialogManage = this.$dialogManage; // 消息框
    this.k2WorkflowLink = Utils.getQueryString("link");

    if (Utils.getLocalStorage("userInfo")) {
      Utils.setSession("userInfo", Utils.getLocalStorage("userInfo"));
    }
    this.$nextTick(() => {
      if (this.$route.query.href && this.$route.query.href != "undefined") {
        this.iframeUrl = `${window.location.href.split("/#/")[0]}${
          this.$route.query.href
        }`;
      } else if (this.$route.query.link) {
        this.iframeUrl =
          window.location.href.split("/#/")[0] +
          this.$route.fullPath
            .split("link=")[1]
            .split("&hash=")[0]
            .replace(/%2F/g, "/")
            .replace(/%23/g, "#")
            .replace(/%3D/g, "=")
            .replace(/%26/g, "&")
            .replace(/%3F/g, "?");
      }
      console.log(this.iframeUrl);
    });
    let oaCode = Utils.getQueryString("code");
    this.oaCode = oaCode || "";
    console.log(this.oaCode, "oaCode");
    // this.getZjInfo()
  },
  mounted() {
    window.addEventListener("message", this.postMessageListener);
    if (Utils.getSession("userInfo")) {
      this.userName = Utils.getSession("userInfo").userName;
      if (
        Utils.getSession("userInfo").mallVos &&
        Utils.getSession("userInfo").mallVos.length > 0
      ) {
        this.shopName = Utils.getSession("userInfo").mallVos[0].mallName;
      }
      // Http.findSysUserInfo({"loginNameOrMobile":Utils.getSession('userInfo').loginName,"companyCode":"10001","loginSource":"E_WEB","loginType":"PASSWORD"}).then(res => {
      //     if(res.data.code == 200){
      //         Utils.setSession('userInfo',res.data.data)
      //     }
      // })
    }
    let imgForm = Utils.getLocalStorage("imgInfo");
    if (imgForm) {
      this.imgForm = imgForm;
    } else {
      this.getImg();
    }
  },
  beforeRouteEnter(to, from, next) {
    let oaCode = Utils.getQueryString("code") || "";
    if (Utils.getLocalStorage("userInfo")) {
      next();
    } else {
      if (!oaCode) {
        next("/login");
      } else {
        next((vm) => {
          let url = `${redirect.baseUrl}/idp/oauth2/authorize?client_id=${redirect.clientId}&redirect_uri=${redirect.redirectUri}&response_type=code&state=`;
          top.location.href = url;
          //top.location.href = `${redirect.baseUrl}/login`
        });
      }
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        // if(val == oldVal){
        //     this.$refs['mainIframe'].contentWindow.location.reload()
        // } else{
        let Url;
        if (val.fullPath.split("?link=").length > 0) {
          Url = val.fullPath.split("?link=")[1];
          Url = Url.split("&hash=")[0];
          if (Url.split("?").length > 1 || Url.split("%3F").length > 1) {
            Url = Url + "&hash=" + new Date().getTime();
          } else {
            Url = Url + "?hash=" + new Date().getTime();
          }
        }
        this.$refs.mainIframe.contentWindow.location.replace(
          Url.replace(/%2F/g, "/")
            .replace(/%23/g, "#")
            .replace(/%3D/g, "=")
            .replace(/%26/g, "&")
            .replace(/%3F/g, "?")
        );

        // this.iframeUrl = Url.replace(/%2F/g,"/").replace(/%23/g,"#").replace(/%3D/g,"=").replace(/%26/g,"&").replace(/%3F/g,"?")
        this.loadingFlagHome = true;
        setTimeout(() => {
          this.loadingFlagHome = false;
        }, 1000);
        //}
      },
      // 深度观察监听
      deep: true,
    },
  },
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
.menuShouqi {
  cursor: pointer;
  margin-right: 4px;
  opacity: 0.9;
}
.home-main {
  /deep/.rs-tabs__header {
    display: none;
  }
}
.tab-top {
  padding: 10px 34px;
  flex: 1;
  /deep/.rs-tabs__header {
    border-bottom-width: 0;
    margin: 0;
  }
  /deep/.rs-tabs__item {
    color: #c1c6c8;
    background: rgba(255, 255, 255, 0.1);
    height: 32px;
    line-height: 32px;
    margin-left: 12px;
    &:hover {
      background: rgba(0, 110, 255, 0.2);
    }
  }
  /deep/.rs-tabs__item.is-active {
    color: #ffffff;
    background: #006eff;
    border-width: 0;
    height: 32px;
    line-height: 32px;
  }
  /deep/.rs-tabs__nav-next,
  /deep/.rs-tabs__nav-prev {
    line-height: 32px;
    color: #c1c6c8;
    font-size: 14px;
    width: 32px;
    text-align: center;
    background: rgba(255, 255, 255, 0.1);
    &:hover {
      background: rgba(0, 110, 255, 0.2);
    }
  }
  .close-all-button {
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    background: rgba(255, 255, 255, 0.1);
    color: #c1c6c8;
    padding: 0px 8px !important;
    border-width: 0;
    border-radius: 0 !important;
    margin-left: 10px;
    &:hover {
      background: rgba(0, 110, 255, 0.2);
    }
  }
}
.booth-box {
  min-height: 368px;
  max-height: 560px;
  overflow-y: scroll;
}
.orgrole-wrap {
  display: flex;
  flex-wrap: wrap;
}
.orgrole-item {
  padding: 0px 12px;
  display: block;
  margin-right: 16px;
  margin-bottom: 16px;
  display: flex;
  font-size: 14px;
  align-items: center;
  width: 160px;
  height: 32px;
  color: #c1c6c8;
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;
  justify-content: space-between;
  &:hover {
    background: rgba(0, 110, 255, 0.2);
    color: #ffffff;
  }
  &:active,
  &.orgrole-item-active {
    background: #006eff;
    color: #ffffff;
  }
  span {
    width: 90%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  i {
    font-size: 14px;
    margin-left: 9px;
    cursor: pointer;
  }
}
.no-editable-tabs {
  background: red;
  background: url("../../assets/images/bg-img.png") no-repeat;
  background-size: 100% 100%;
  background-attachment: fixed;
}
.no-editable-main {
  background: none !important;
}
.name-text {
  height: 100%;
  width: 100%;
  font-size: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 600;
  letter-spacing: 10px;
}
</style>
<style lang="less" >
.all-tabs-popover {
  background: #21335c !important;
  padding: 20px !important;
  .popper__arrow::after {
    border-bottom-color: #21335c !important;
  }
}
</style>

